/**
 * 应用主入口文件
 * - 挂载 React 应用到 DOM #root 节点
 * - ConfigProvider 注入 Ant Design 主题 Token（橙色宠物风格）
 * - AntApp 包裹提供 message/notification/modal 静态方法上下文
 * - RouterProvider 接入 react-router-dom v6 数据路由
 */
import React from 'react'
import '@/styles/global.scss'
import {router} from './router'
import '@/styles/antd-override.scss'
// 大白话：antd/locale/zh_CN 把日期、分页、空状态等默认文案切成中文。
import zhCN from 'antd/locale/zh_CN'
import {createRoot} from 'react-dom/client'
import {RouterProvider} from 'react-router-dom'

import {ConfigProvider, App as AntApp} from 'antd'

/** Ant Design 主题 Token — 与 UI 设计规范保持一致 */
const themeToken = {
  colorPrimary: '#ff6b35', // 主色：暖橙色
  colorSuccess: '#52c41a', // 成功色
  colorWarning: '#faad14', // 警告色
  colorError: '#ff4d4f', // 错误色
  borderRadius: 8, // 默认圆角
  fontFamily: "-apple-system, 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', sans-serif"
}

const root = createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{token: themeToken}}>
      <AntApp>
        <RouterProvider router={router} />
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>
)
